import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col relative max-h-screen p-4 md:p-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Breakdown of loan over its lifetime ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoanDetailsHeading = _resolveComponent("LoanDetailsHeading")!
  const _component_LoanDetailsOptions = _resolveComponent("LoanDetailsOptions")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HeadingWithMargin = _resolveComponent("HeadingWithMargin")!
  const _component_LoanDetailsBreakdown = _resolveComponent("LoanDetailsBreakdown")!
  const _component_LoanDetailsTotalInterest = _resolveComponent("LoanDetailsTotalInterest")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoanDetailsHeading, { lender: _ctx.lender }, null, 8, ["lender"]),
    _createVNode(_component_Card, { class: "grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 items-center p-4 md:p-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_LoanDetailsOptions, _mergeProps({ loanAmount: _ctx.loanAmount, margin: _ctx.margin, baseInterestRate: _ctx.baseInterestRate, startDate: _ctx.startDate, endDate: _ctx.endDate }, { onEditLoan: _ctx.edit }), null, 16, ["onEditLoan"])
      ]),
      _: 1
    }),
    _createVNode(_component_HeadingWithMargin, { tag: "h2" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_Card, { class: "flex-1 overflow-hidden" }, {
      default: _withCtx(() => [
        _createVNode(_component_LoanDetailsBreakdown, { breakdown: _ctx.breakdown }, null, 8, ["breakdown"])
      ]),
      _: 1
    }),
    _createVNode(_component_LoanDetailsTotalInterest, { "total-interest": _ctx.totalInterest }, null, 8, ["total-interest"])
  ]))
}